import { IconWrapper } from '../runtime';
export default IconWrapper('template', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M4 3.74976C4 3.47361 4.22386 3.24976 4.5 3.24976H11.5C11.7761 3.24976 12 3.47361 12 3.74976V5.99976C12 6.2759 11.7761 6.49976 11.5 6.49976H4.5C4.22386 6.49976 4 6.2759 4 5.99976V3.74976Z",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M4.75 8.74976H11.25M4.75 11.7498H8.25M3.25 14.9998H12.75C13.5784 14.9998 14.25 14.3282 14.25 13.4998V2.49976C14.25 1.67133 13.5784 0.999756 12.75 0.999756H3.25C2.42157 0.999756 1.75 1.67133 1.75 2.49976V13.4998C1.75 14.3282 2.42157 14.9998 3.25 14.9998Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});